import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import {
  formatNumber,
  get120PercentOf,
  getCurrencyCode,
  isActivityFree,
  isActivityPaid,
  isAnyOtherAllowed,
} from "../../../../../helpers/CommonHelper";
import { PieChart } from "react-minimal-pie-chart";
import { GoAlertFill } from "react-icons/go";
import { FaCircleCheck } from "react-icons/fa6";
import { FaTimesCircle } from "react-icons/fa";
import { FaFileAlt } from "react-icons/fa";
import StatsListingNew from "../../../../UI/shared/infoListing/StatsListingNew";
const Item = ({
  item,
  handleCheckBoxClick,
  isCheck,
  moduleConfig,
  confirmAndDelete,
  confirmAndDisabled,
  confirmAndEnabled,
  index,
}) => {
  const users = [
    {
      capacity: 50,
      confirmed: 20,
      notConfirmed: 10,
      total: 30,
      paymentPending: 2,
      adminApprovalsPending: 8,
    },
    {
      capacity: 20,
      confirmed: 20,
      notConfirmed: 10,
      total: 30,
      paymentPending: 5,
      adminApprovalsPending: 5,
    },
    {
      capacity: 10,
      confirmed: 8,
      notConfirmed: 2,
      total: 10,
      paymentPending: 2,
      adminApprovalsPending: 0,
    },
  ];

  const fields = moduleConfig.fields;
  const getItems = () => {
    let items = [];

    if (item.capacityType) {
      items = [
        ...items,
        {
          text: "Capacity Type",
          value:
            item.capacityType[0].toUpperCase() + item.capacityType.slice(1),
          type: "text",
        },
      ];
    }

    if (item.capacityType === "limited") {
      items = [
        ...items,
        { text: "Max. Allowed Capacity", value: item.capacity, type: "text" },
      ];
    }

    if (item.target) {
      items = [...items, { text: "Target", value: item.target, type: "text" }];
    }
    if (item.target && item.target !== "All-Members") {
      items = [
        ...items,

        {
          text:
            "Target " +
            (item.target === "Selected-Circles"
              ? " Circles "
              : item.target === "Selected-Members"
                ? " Members "
                : null) +
            "Count",
          value:
            item.target === "Selected-Circles"
              ? item.targetedCirclesCount
                ? item.targetedCirclesCount
                : "Targets not added yet"
              : item.target === "Selected-Members"
                ? item.targetedMembersCount
                  ? item.targetedMembersCount
                  : "Targets not added yet"
                : 0,
          type: "text",
        },
      ];
    }
    if (item.location) {
      items = [
        ...items,
        {
          text: "Location",
          value: item.location,
          type: "text",
          disable: true,
        },
      ];
    }

    return items;
  };
  const getItems2 = () => {
    let items = [];
    if (item.paidActivity) {
      items = [
        ...items,
        {
          text: "Paid Activity",
          value: item.paidActivity,
          type: "boolean",
        },
      ];
    }
    if (item.participationFee) {
      items = [
        ...items,
        {
          text: "Participation Fee ",
          value: formatNumber(item.participationFee) + " " + getCurrencyCode(),
          type: "text",
        },
      ];
    }
    if (item.partnerFeaturesSettings && item.partnerFeaturesSettings.allowed) {
      items = [
        ...items,
        {
          text: "Partner Allowed",
          value:
            item.partnerFeaturesSettings &&
            item.partnerFeaturesSettings.allowed == "1" &&
            item.partnerFeaturesSettings.allowed,
          type: "boolean",
        },
      ];
    }
    if (
      item.partnerFeaturesSettings &&
      item.partnerFeaturesSettings.allowed == "1" &&
      item.partnerFeaturesSettings.paidParticipation
    ) {
      items = [
        ...items,
        {
          text: "Paid Partner Participation",
          value:
            item.partnerFeaturesSettings &&
            item.partnerFeaturesSettings.allowed == "1" &&
            item.partnerFeaturesSettings.paidParticipation,
          type: "boolean",
        },
      ];
    }
    if (
      item.partnerFeaturesSettings &&
      item.partnerFeaturesSettings.allowed == "1" &&
      item.partnerFeaturesSettings.participationFee
    ) {
      items = [
        ...items,
        {
          text: "Partner Participation Fee ",
          value:
            item.partnerFeaturesSettings &&
            item.partnerFeaturesSettings.allowed == "1" &&
            formatNumber(item.partnerFeaturesSettings.participationFee) +
              " " +
              getCurrencyCode(),
          type: "text",
        },
      ];
    }

    if (item.guestFeaturesSettings && item.guestFeaturesSettings.allowed) {
      items = [
        ...items,
        {
          text: "Guests Allowed",
          value:
            item.guestFeaturesSettings &&
            item.guestFeaturesSettings.allowed == "1" &&
            item.guestFeaturesSettings.allowed,
          type: "boolean",
        },
      ];
    }
    if (
      item.guestFeaturesSettings &&
      item.guestFeaturesSettings.allowed == "1" &&
      item.guestFeaturesSettings.paidParticipation
    ) {
      items = [
        ...items,
        {
          text: "Paid Guest Participation",
          value:
            item.guestFeaturesSettings &&
            item.guestFeaturesSettings.allowed == "1" &&
            item.guestFeaturesSettings.paidParticipation,
          type: "boolean",
        },
      ];
    }
    if (
      item.guestFeaturesSettings &&
      item.guestFeaturesSettings.allowed == "1" &&
      item.guestFeaturesSettings.participationFee
    ) {
      items = [
        ...items,
        {
          text: "Guest Participation Fee",
          value:
            item.guestFeaturesSettings &&
            item.guestFeaturesSettings.allowed == "1" &&
            formatNumber(item.guestFeaturesSettings.participationFee) +
              " " +
              getCurrencyCode(),
          type: "text",
        },
      ];
    }
    if (
      item.guestFeaturesSettings &&
      item.guestFeaturesSettings.allowed !== "0" &&
      item.guestFeaturesSettings.allowedNumbers
    ) {
      items = [
        ...items,
        {
          text: "Allowed Number of Guests",
          value:
            item.guestFeaturesSettings &&
            item.guestFeaturesSettings.allowed !== "0" &&
            item.guestFeaturesSettings.allowedNumbers,
        },
      ];
    }

    ///Kids Feature Settings

    if (item.kidsFeaturesSettings && item.kidsFeaturesSettings.allowed) {
      items = [
        ...items,
        {
          text: "Kids Allowed",
          value:
            item.kidsFeaturesSettings &&
            item.kidsFeaturesSettings.allowed == "1" &&
            item.kidsFeaturesSettings.allowed,
          type: "boolean",
        },
      ];
    }
    if (
      item.kidsFeaturesSettings &&
      item.kidsFeaturesSettings.allowed == "1" &&
      item.kidsFeaturesSettings.paidParticipation
    ) {
      items = [
        ...items,
        {
          text: "Paid Kids Participation",
          value:
            item.kidsFeaturesSettings &&
            item.kidsFeaturesSettings.allowed == "1" &&
            item.kidsFeaturesSettings.paidParticipation,
          type: "boolean",
        },
      ];
    }
    if (
      item.kidsFeaturesSettings &&
      item.kidsFeaturesSettings.allowed == "1" &&
      item.kidsFeaturesSettings.participationFee
    ) {
      items = [
        ...items,
        {
          text: "Kids Participation Fee",
          value:
            item.kidsFeaturesSettings &&
            item.kidsFeaturesSettings.allowed == "1" &&
            formatNumber(item.kidsFeaturesSettings.participationFee) +
              " " +
              getCurrencyCode(),
          type: "text",
        },
      ];
    }
    if (
      item.kidsFeaturesSettings &&
      item.kidsFeaturesSettings.allowed !== "0" &&
      item.kidsFeaturesSettings.allowedNumbers
    ) {
      items = [
        ...items,
        {
          text: "Allowed Number of Kids",
          value:
            item.kidsFeaturesSettings &&
            item.kidsFeaturesSettings.allowed !== "0" &&
            item.kidsFeaturesSettings.allowedNumbers,
        },
      ];
    }

    return items;
  };
  function getObjectByIndex(arr, index) {
    if (index >= 0 && index < arr.length) {
      return arr[index]; // Return the object at the specified index
    } else {
      return null; // Return null if index is out of bounds
    }
  }
  function findPercentage(part, total) {
    if (!part || !total) {
      return 0;
    }
    if (total === 0) {
      return 0; // Avoid division by zero
    }
    return Math.round((part / total) * 100 * 100) / 100; // Round to 2 decimal places
  }

  return (
    <Card className="item mb-3">
      <Card.Header className="ps-1 pe-2 py-0">
        <Card.Title className="d-flex m-0 p-0">
          <div className="d-flex ImageSectionSpacing">
            <div className="checkboxCol me-2 ms-2 mt-2">
              <input
                type="checkbox"
                id={item._id}
                name={item._id}
                onChange={handleCheckBoxClick}
                checked={isCheck.includes(item._id)}
              />
            </div>

            <div className="ms-1 me-2 ">
              <i className="fas fa-calendar position-relative usericon ">
                {(item.status === "0" || item.status === 0) && (
                  <i className="fas fa-ban position-absolute banned"></i>
                )}
              </i>
            </div>

            <div className="d-flex flex-column ms-1">
              <span className="m-0 text-bold memberName">{item.title}</span>

              <span className="font-italic font-small font-weight-normal text-success fs-8  ">
                <span className="membershipId">
                  <ModuleDisplayDate value={item.date} />{" "}
                  {item.time && " - " + item.time}
                </span>
              </span>
            </div>
          </div>
        </Card.Title>

        <div class="card-tools mb-1">
          <div>
            {(item.pastActivity === "1" || item.pastActivity === 1) && (
              <span className="badge pastActivity me-1 text-dark">
                Past Activity
              </span>
            )}
            {item.status === "1" || item.status === 1 ? (
              <span className="badge badge-success  me-1 text-light">
                Enabled
              </span>
            ) : (
              <span className="badge badge-warning  me-1 text-dark">
                Disabled
              </span>
            )}

            {/* <span className="badge badge-light me-1 text-dark">
              Status :{" "}
              <span class="text-secondary">
                <ModuleDisplayBoolean
                  value={item.status}
                  trueValue="Enabled"
                  falseValue="Disabled"
                />{" "}
              </span>
            </span> */}

            <span class="badge badge-light me-1 text-dark">
              Created Date/Time :{" "}
              <span class="text-secondary">
                <ModuleDisplayDateTime value={item.createdAt} />{" "}
              </span>
            </span>
          </div>

          <div className=" text-right me-xl-2  mt-1">
            <Link
              to={`/${moduleConfig.url}/${item._id}`}
              className="btn btn-outline-secondary  listingActionIcon"
              title="View Item details"
            >
              <i className="fas fa-eye"></i>
            </Link>

            <Link
              to={`/${moduleConfig.url}/update/${item._id}`}
              className="btn btn-outline-secondary listingActionIcon"
              title="Update Item"
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            {(item.status === "1" || item.status === 1) && (
              <span
                title="Disable Activity"
                onClick={() => confirmAndDisabled(item._id)}
                className="btn btn-outline-secondary  listingActionIcon"
              >
                <i className="fas fa-ban"></i>
              </span>
            )}

            {(item.status === "0" || item.status === 0) && (
              <span
                title="Enable Activity"
                onClick={() => confirmAndEnabled(item._id)}
                className="btn btn-outline-secondary listingActionIcon"
              >
                <i className="fas fa-undo"></i>
              </span>
            )}
          </div>
        </div>
      </Card.Header>
      <Card.Body className="p-1 py-0">
        <Row className="w-100 mx-auto">
          <Col xl={12} lg={12} md={12} sm={12} xs={12} className="p-0 m-0">
            {item.registrationsCount <= 0 && (
              <div className="alertNotApplicable small fontItalic mb-1">
                No registrations yet for this activity
              </div>
            )}

            {/* <Card className=" mt-0 my-0">
              <Card.Body className="p-1 px-2 d-flex flex-wrap">
                <div className={`holder ms-0`}>
                  <p className="title">Capacity Type : </p>
                  <p className="value ms-2"> {item.capacityType}</p>
                </div>
                {item.capacityType === "limited" && item.capacity &&
                  <div className={`holder`}>
                    <p className="title">Max. Allowed Capacity: </p>
                    <p className="value ms-2"> {item.capacity}</p>
                  </div>}
                {item.target && <div className={`holder`}>
                  <p className="title">Target: </p>
                  <p className="value ms-2"> {item.target}</p>
                </div>}

                {item.target && item.target !== "All-Members" &&
                  <div className={`holder`}>
                    <p className="title">{item.target === "Selected-Circles"
                      ? " Circles "
                      : item.target === "Selected-Members"
                        ? " Members "
                        : null}: </p>
                    <p className="value ms-2"> {item.target === "Selected-Circles"
                      ? item.targetedCirclesCount
                        ? item.targetedCirclesCount
                        : "Targets not added yet"
                      : item.target === "Selected-Members"
                        ? item.targetedMembersCount
                          ? item.targetedMembersCount
                          : "Targets not added yet"
                        : 0}</p>
                  </div>}
                {item.location && <div className={`holder`}>
                  <p className="title">Location: </p>
                  <p className="value ms-2"> {item.location}</p>
                </div>}


              </Card.Body>
            </Card> */}
            <Card className=" mt-0 my-0 activityFeeCard">
              <Card.Body className="p-1 px-2 d-flex align-items-center flex-wrap">
                {/* <div className={`holder ms-0`}>
                  <p className="title">Capacity Type : </p>
                  <p className="value ms-2"> {item.capacityType}</p>
                </div>
                {item.capacityType === "limited" && item.capacity &&
                  <div className={`holder`}>
                    <p className="title">Max. Allowed Capacity: </p>
                    <p className="value ms-2"> {item.capacity}</p>
                  </div>}
                {item.target && <div className={`holder`}>
                  <p className="title">Target: </p>
                  <p className="value ms-2"> {item.target}</p>
                </div>}

                {item.target && item.target !== "All-Members" &&
                  <div className={`holder`}>
                    <p className="title">{item.target === "Selected-Circles"
                      ? " Circles "
                      : item.target === "Selected-Members"
                        ? " Members "
                        : null}: </p>
                    <p className="value ms-2"> {item.target === "Selected-Circles"
                      ? item.targetedCirclesCount
                        ? item.targetedCirclesCount
                        : "Targets not added yet"
                      : item.target === "Selected-Members"
                        ? item.targetedMembersCount
                          ? item.targetedMembersCount
                          : "Targets not added yet"
                        : 0}</p>
                  </div>}
                {item.location && <div className={`holder`}>
                  <p className="title">Location: </p>
                  <p className="value ms-2"> {item.location}</p>
                </div>} */}

                <div className="activityFeeCardMargin center ps-0">
                  {item.target && (
                    <div className={`holder border-0`}>
                      <p className="title">Target: </p>
                      <p className="value ms-2"> {item.target}</p>
                    </div>
                  )}

                  {item.target && item.target !== "All-Members" && (
                    <div className={`holder border-0`}>
                      <p className="title">
                        {item.target === "Selected-Circles"
                          ? " Circles "
                          : item.target === "Selected-Members"
                            ? " Members "
                            : null}
                        :{" "}
                      </p>
                      <p className="value ms-2">
                        {" "}
                        {item.target === "Selected-Circles"
                          ? item.targetedCirclesCount
                            ? item.targetedCirclesCount
                            : "Targets not added yet"
                          : item.target === "Selected-Members"
                            ? item.targetedMembersCount
                              ? item.targetedMembersCount
                              : "Targets not added yet"
                            : 0}
                      </p>
                    </div>
                  )}
                  {item.location && (
                    <div className={`holder border-0`}>
                      <p className="title">Location: </p>
                      <p className="value ms-2"> {item.location}</p>
                    </div>
                  )}
                </div>
                <div className="activityFeeCardMargin center ps-0">
                  <div className={`holder  border-0`}>
                    <p className="title">Capacity Type : </p>
                    <p className="value ms-2"> {item.capacityType}</p>
                  </div>
                  {item.capacityType === "limited" && item.capacity && (
                    <div className={`holder border-0`}>
                      <p className="title">Max. Allowed Capacity: </p>
                      <p className="value ms-2"> {item.capacity}</p>
                    </div>
                  )}
                </div>
                <div className="activityFeeCardMargin ps-0">
                  <div className="carTopHolder mb-0 border-0 pb-0">
                    <div className="carLeftHolder activity">
                      Activity Participation
                    </div>
                    <div className="carRightHolder">
                      <FaCircleCheck size={14} className="text-success hide" />
                    </div>
                  </div>
                  {item.paidActivity === "1" && item.participationFee ? (
                    <div className="carDownHolder">
                      {item.participationFee + " " + getCurrencyCode()}
                    </div>
                  ) : (
                    <div className="carDownHolder">Free</div>
                  )}
                </div>

                <div className="activityFeeCardMargin ps-0">
                  <div className="carTopHolder mb-0 border-0 pb-0">
                    <div className="carLeftHolder activity">
                      Partner Participation
                    </div>
                    <div className="carRightHolder">
                      {item.partnerFeaturesSettings &&
                      item.partnerFeaturesSettings.allowed === "1" ? (
                        <FaCircleCheck size={14} className="text-success" />
                      ) : (
                        <FaTimesCircle size={14} className="text-danger" />
                      )}
                    </div>
                  </div>
                  {item.partnerFeaturesSettings && (
                    <>
                      {item.partnerFeaturesSettings.allowed === "1" ? (
                        <div className="carDownHolder">
                          {item.partnerFeaturesSettings.paidParticipation ===
                          "1"
                            ? item.partnerFeaturesSettings.participationFee
                              ? item.partnerFeaturesSettings.participationFee +
                                " " +
                                getCurrencyCode()
                              : "Free"
                            : "Free"}
                        </div>
                      ) : (
                        <div className="carDownHolder text">Not Allowed</div>
                      )}
                    </>
                  )}
                </div>

                <div className="activityFeeCardMargin ps-0">
                  <div className="carTopHolder mb-0 border-0 pb-0">
                    <div className="carLeftHolder activity">
                      Guest Participation
                    </div>
                    <div className="carRightHolder">
                      {item.guestFeaturesSettings &&
                      item.guestFeaturesSettings.allowed === "1" ? (
                        <FaCircleCheck size={14} className="text-success" />
                      ) : (
                        <FaTimesCircle size={14} className="text-danger" />
                      )}
                    </div>
                  </div>

                  {item.guestFeaturesSettings && (
                    <>
                      {item.guestFeaturesSettings.allowed === "1" ? (
                        <div className="carDownHolder">
                          {/* <small className="text-secondary maxAllowed fontItalic">{item.guestFeaturesSettings.allowedNumbers} allowed</small> */}
                          <p className="mb-0">
                            {item.guestFeaturesSettings.paidParticipation ===
                            "1"
                              ? item.guestFeaturesSettings.participationFee
                                ? item.guestFeaturesSettings.participationFee +
                                  " " +
                                  getCurrencyCode()
                                : "Free"
                              : "Free"}{" "}
                          </p>
                        </div>
                      ) : (
                        <div className="carDownHolder text">Not Allowed</div>
                      )}
                      {item.guestFeaturesSettings.allowed === "1" && (
                        <p
                          className={`small mb-0 text-secondary mt-1  fs-14 float-end `}
                        >
                          {" "}
                          Admin Approval :{" "}
                          <span
                            className={`  ${
                              item?.guestFeaturesSettings
                                ?.requireAdminApproval === "0"
                                ? "text-pink"
                                : "text-success"
                            }`}
                          >
                            {item?.guestFeaturesSettings
                              ?.requireAdminApproval === "0"
                              ? "Not Required"
                              : "Required"}
                          </span>
                        </p>
                      )}
                    </>
                  )}
                </div>
                <div className="activityFeeCardMargin ps-0">
                  <div className="carTopHolder mb-0 border-0 pb-0">
                    <div className="carLeftHolder activity">
                      Kids Participation
                    </div>
                    <div className="carRightHolder">
                      {item.kidsFeaturesSettings &&
                      item.kidsFeaturesSettings.allowed === "1" ? (
                        <FaCircleCheck size={14} className="text-success" />
                      ) : (
                        <FaTimesCircle size={14} className="text-danger" />
                      )}
                    </div>
                  </div>
                  {item.kidsFeaturesSettings && (
                    <>
                      {item.kidsFeaturesSettings.allowed === "1" ? (
                        <div className="carDownHolder">
                          {item.kidsFeaturesSettings.paidParticipation === "1"
                            ? item.kidsFeaturesSettings.participationFee
                              ? item.kidsFeaturesSettings.participationFee +
                                " " +
                                getCurrencyCode()
                              : "Free"
                            : "Free"}
                        </div>
                      ) : (
                        <div className="carDownHolder text">Not Allowed</div>
                      )}
                      {item.kidsFeaturesSettings.allowed === "1" && (
                        <p
                          className={`small mb-0 text-secondary mt-1  fs-14 float-end
  
    `}
                        >
                          {" "}
                          Admin Approval :{" "}
                          <span
                            className={`  ${
                              item?.kidsFeaturesSettings
                                ?.requireAdminApproval === "0"
                                ? "text-pink"
                                : "text-success"
                            }`}
                          >
                            {item?.kidsFeaturesSettings
                              ?.requireAdminApproval === "0"
                              ? "Not Required"
                              : "Required"}
                          </span>
                        </p>
                      )}
                    </>
                  )}
                </div>

                {/* <div>
                  <Link to={`/activity-registrations/${item._id}`} className="activityFeeCardMargin d-flex align-items-center justify-content-center primary cursor-pointer ">
                    <div className="carTopHolder mb-0 border-0 pb-0 py-1">
                      <div className="carLeftHolder activity"> <FaFileAlt size={18} className="me-1" />Manage Registrations {item.registrationsCount > 0 ? `(${item.registrationsCount})` : "(0)"} </div>
                      <div className="carRightHolder">

                      </div>
                    </div>
                    
                  </Link>
                </div>
                {item.capacityStats.total.registered > 0 &&
                  <div>
                    <Link to={`/activity-registrations/${item._id}`} className="activityFeeCardMargin d-flex align-items-center justify-content-center pink cursor-pointer ">
                      <div className="carTopHolder mb-0 border-0 pb-0 py-1">
                        <div className="carLeftHolder activity"> <FaFileAlt size={18} className="me-1" />Total Participants {item.capacityStats.total.registered > 0 ? `(${item.capacityStats.total.registered})` : "(0)"} </div>
                        <div className="carRightHolder">

                        </div>
                      </div>
                      
                    </Link>
                  </div>}
                {isActivityFree(item) &&
                  <div>
                    <Link to={`/activity-registrations/${item._id}?status=reconfirmedMembers`} className="activityFeeCardMargin d-flex align-items-center justify-content-center green cursor-pointer ">
                      <div className="carTopHolder mb-0 border-0 pb-0 py-1">
                        <div className="carLeftHolder activity"> <FaCircleCheck size={17} className="me-1" />Confirmed Participants {item.capacityStats.total.reconfirmedRegistrations > 0 ? `(${item.capacityStats.total.reconfirmedRegistrations})` : "(0)"} </div>
                        <div className="carRightHolder">

                        </div>
                      </div>
                     
                    </Link>
                  </div>} */}

                {/* {item.capacityType === "unlimited" && item.capacityStats.total.registered > 0 && !isActivityPaid(item) &&
                  <Link to={`/activity-registrations/${item._id}`} className="activityFeeCardMargin register primary mt-1">
                    <div className="carTopHolder mb-0 border-0 pb-0">
                      <div className="carLeftHolder activity">   <FaFileAlt size={18} className="me-1" /> Registration(s)</div>
                      <div className="carRightHolder">
                        {item.capacityStats.total.registered}
                      </div>
                    </div>
                    
                  </Link>} */}
              </Card.Body>
            </Card>
          </Col>
          {item.capacityType === "limited" &&
            item.capacityStats &&
            item.capacityStats.total.registered > 0 && (
              <Col xl={12} lg={12} md={12} sm={12} xs={12} className="p-0 ">
                <div
                  className={`activityStats mt-1 pt-1 ${item.capacityStats && item.capacityStats.total && item.capacityStats.total.registeredConfirmedPercentage >= 100 ? "alert-danger" : item.capacityStats && item.capacityStats.total && item.capacityStats.total.registered >= get120PercentOf(item.capacity) ? "alert-warning" : ""}`}
                >
                  <Row className="w-100">
                    <Col
                      xl={12}
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className="max87 d-flex align-items-center justify-content-start flex-wrap"
                    >
                      {/* {isActivityPaid(item) &&
                      <div className="pieContainer mb-0 ">
                        <div className="pie-wrapper">
                          <PieChart
                            animate
                            animationDuration={500}
                            animationEasing="ease-out"
                            center={[55, 65]}
                            lengthAngle={360}
                            lineWidth={50}
                            paddingAngle={5}
                            radius={50}
                            startAngle={0}
                            viewBoxSize={[120, 120]}
                            label={({ dataEntry }) => `${dataEntry.value}`}
                            labelPosition={70}
                            labelStyle={{
                              fontSize: '12px',
                              fill: "#FFFFFA",
                              fontWeight: 'bold',
                              textShadow: '1px 1px 3px rgba(255, 255, 255, 0.4)',
                            }}
                            data={[
                              { title: 'Confirmed', value: item.capacityStats.total.registeredConfirmed, color: '#000' },  // Lighter green
                              { title: 'Not Confirmed', value: item.capacityStats.total.registeredNotConfirmed, color: '#999' },  // Yellow
                            ]}
                            style={{
                              width: '100%',
                              height: 'auto',
                            }}
                          />

                        </div>
                        <div className="pieLabels">
                          <div className="displayRow mt-0 p-0 ">
                            <div className="leftText"><p><span className="confirmedBox"></span> Confirmed : {item.capacityStats.total.registeredConfirmed}  </p></div>
                            <div className="rightText">
                              <p className="mb-0"><span className="count ">({findPercentage(item.capacityStats.total.registeredConfirmed, item.capacityStats.total.allowed)}%)</span></p>
                            </div>
                          </div>

                          <div className="displayRow mt-0 p-0">
                            <div className="leftText"> <p><span className="notConfirmedBox"></span> Not Confirmed : {item.capacityStats.total.registeredNotConfirmed}  </p></div>
                            <div className="rightText">
                              <p className="mb-0"><span className="count ">({findPercentage(item.capacityStats.total.registeredNotConfirmed, item.capacityStats.total.allowed)}%)</span></p>
                            </div>
                          </div>
                          <div className="displayRow  mt-0  p-0">
                            <div className="leftText"> <p className="soFar font-weight-bold">Total Registrations: {item.capacityStats.total.registered}</p> </div>
                            <div className="rightText">
                              <p className="mb-0"><span className="count font-weight-bold  soFar">({findPercentage(item.capacityStats.total.registered, item.capacityStats.total.allowed)}%)</span></p>
                            </div>
                          </div>


                        </div>
                      </div>} */}

                      <div className="d-flex flex-wrap align-items-center justify-content-start">
                        <div>
                          <div className="infoBox ps-0 mb-0 pb-0 me-4">
                            <div className=" mr-3">
                              <p className="infoHead mb-0">
                                Registrations Capacity
                              </p>

                              {item.capacityStats &&
                              item.capacityStats.total &&
                              item.capacityStats.total
                                .registeredConfirmedPercentage >= 100 ? (
                                <p class=" capacityAlertRed mt-1 p-0 px-1 mb-0">
                                  <GoAlertFill />{" "}
                                  {isActivityFree(item)
                                    ? "Registrations reached the limit."
                                    : "Confirmed registrations reached the limit."}
                                </p>
                              ) : (
                                item.capacityStats &&
                                item.capacityStats.total &&
                                item.capacityStats.total.registered >=
                                  get120PercentOf(item.capacity) && (
                                  <p class=" capacityAlertYellow mt-1 p-0 px-1 mb-0">
                                    <GoAlertFill /> Total registrations reached
                                    maximum capacity
                                  </p>
                                )
                              )}
                              {isActivityFree(item) &&
                                item.capacityStats &&
                                item.capacityStats.total &&
                                item.capacityStats.total.registeredPercentage >
                                  10 &&
                                item.capacityStats.total.registeredPercentage <
                                  100 && (
                                  <>
                                    {item.capacityStats &&
                                    item.capacityStats.total &&
                                    item.capacityStats.total
                                      .registeredPercentage > 10 ? (
                                      <p className="alertGreen w-100 p-0 mb-0 text-success">
                                        {" "}
                                        {
                                          item.capacityStats.total
                                            .registeredPercentage
                                        }
                                        % of total capacity.{" "}
                                      </p>
                                    ) : (
                                      <p className="alertGreen w-100 p-0 mb-0 text-success">
                                        {" "}
                                        {findPercentage(
                                          item.capacityStats.total.registered,
                                          item.capacityStats.total.allowed,
                                        )}
                                        % of total Capacity is registered.
                                      </p>
                                    )}
                                  </>
                                )}
                              {isActivityPaid(item) &&
                                item.capacityStats &&
                                item.capacityStats.total &&
                                item.capacityStats.total
                                  .registeredConfirmedPercentage > 10 &&
                                item.capacityStats.total
                                  .registeredConfirmedPercentage < 100 && (
                                  <>
                                    {item.capacityStats &&
                                    item.capacityStats.total &&
                                    item.capacityStats.total
                                      .registeredConfirmedPercentage > 10 ? (
                                      <p className="alertGreen w-100 p-0 mb-0 text-success">
                                        {" "}
                                        {
                                          item.capacityStats.total
                                            .registeredConfirmedPercentage
                                        }
                                        % of total capacity is confirmed
                                      </p>
                                    ) : (
                                      <p className="alertGreen w-100 p-0 mb-0 text-success">
                                        {" "}
                                        {findPercentage(
                                          item.capacityStats.total.registered,
                                          item.capacityStats.total.allowed,
                                        )}
                                        % of total Capacity is registered.
                                      </p>
                                    )}
                                  </>
                                )}
                            </div>
                            <div className="ms-2">
                              <h2 className="infoCount pb-0">
                                {item.capacityStats &&
                                  item.capacityStats.total.registered}
                                /
                                {item.capacityStats &&
                                  item.capacityStats.total.allowed}
                              </h2>
                            </div>
                          </div>
                          {item.capacityType === "limited" && (
                            <Link
                              to={`/${moduleConfig.url}/update/${item._id}`}
                            >
                              <div
                                className={`statsActionsButton text-left pb-1`}
                              >
                                Increase Capacity
                              </div>
                            </Link>
                          )}
                        </div>

                        <div>
                          <Link
                            to={`/activity-registrations/${item._id}`}
                            className="activityFeeCardMargin d-flex align-items-center justify-content-center purple cursor-pointer "
                          >
                            <div className="carTopHolder mb-0 border-0 pb-0 py-1">
                              <div className="carLeftHolder activity">
                                {" "}
                                <FaFileAlt size={18} className="me-1" />
                                Manage Registrations{" "}
                                <i className="regType">(Members Only)</i> &nbsp;
                                - &nbsp;{" "}
                                <b>
                                  {item.registrationsCount > 0
                                    ? `${item.registrationsCount}`
                                    : "0"}{" "}
                                </b>
                              </div>
                              <div className="carRightHolder"></div>
                            </div>
                            {/* <div className="carDownHolder warning">{item.stats.cars}</div> */}
                          </Link>
                        </div>
                        {item.capacityStats.total.registered > 0 && (
                          <div>
                            <Link
                              to={`/activity-registrations/${item._id}`}
                              className="activityFeeCardMargin d-flex align-items-center justify-content-center primary cursor-pointer "
                            >
                              <div className="carTopHolder mb-0 border-0 pb-0 py-1">
                                <div className="carLeftHolder activity">
                                  {" "}
                                  <FaFileAlt size={18} className="me-1" /> Total
                                  Registrations{" "}
                                  <i className="regType">(Members + Others)</i>{" "}
                                  &nbsp; - &nbsp;{" "}
                                  <b>
                                    {item.capacityStats.total.registered > 0
                                      ? `${item.capacityStats.total.registered}`
                                      : "0"}{" "}
                                  </b>
                                </div>
                                <div className="carRightHolder"></div>
                              </div>
                              {/* <div className="carDownHolder warning">{item.stats.cars}</div> */}
                            </Link>
                          </div>
                        )}
                        {/* {isActivityFree(item) &&
                        <div>
                          <Link to={`/activity-registrations/${item._id}?status=reconfirmedMembers`} className="me-3 activityFeeCardMargin d-flex align-items-center justify-content-center green cursor-pointer ">
                            <div className="carTopHolder mb-0 border-0 pb-0 py-1">
                              <div className="carLeftHolder activity"> <FaCircleCheck size={17} className="me-1" />Confirmed Participants {item.capacityStats.total.reconfirmedRegistrations > 0 ? `(${item.capacityStats.total.reconfirmedRegistrations})` : "(0)"} </div>
                              <div className="carRightHolder">

                              </div>
                            </div>
                            
                          </Link>
                        </div>} */}
                        {isActivityPaid(item) && (
                          <div>
                            <Link
                              to={`/activity-registrations/${item._id}?status=confirmedMembers`}
                              className="activityFeeCardMargin me-3 d-flex align-items-center justify-content-center green cursor-pointer "
                            >
                              <div className="carTopHolder mb-0 border-0 pb-0 py-1">
                                <div className="carLeftHolder activity">
                                  {" "}
                                  <FaCircleCheck size={17} className="me-1" />
                                  Confirmed Registrations{" "}
                                  <i className="regType">
                                    (Members + Others)
                                  </i>{" "}
                                  &nbsp; - &nbsp;{" "}
                                  <b>
                                    {" "}
                                    {item.capacityStats.total
                                      .registeredConfirmed > 0
                                      ? `${item.capacityStats.total.registeredConfirmed}`
                                      : "0"}
                                  </b>{" "}
                                </div>
                                <div className="carRightHolder"></div>
                              </div>
                            </Link>
                          </div>
                        )}

                        <div className="d-flex flex-wrap">
                          {item.capacityStats.total.registeredPaymentPending >
                            0 && (
                            <div className="me-5">
                              {item.capacityStats.total
                                .registeredPaymentPending > 0 ? (
                                <div className="progressContainer ">
                                  {item.capacityStats.total
                                    .registeredPaymentPending > 0 && (
                                    <div className="progressWrapper">
                                      <p className="progressText">
                                        Payment Pending{" "}
                                        <span className="font-weight-bold">
                                          (
                                          {
                                            item.capacityStats.total
                                              .registeredPaymentPending
                                          }
                                          )
                                        </span>
                                      </p>
                                      <div className="progressBar pendingPayment">
                                        <div
                                          className="progressFill"
                                          style={{
                                            width: `${findPercentage(item.capacityStats.total.registeredPaymentPending, item.capacityStats.total.registered)}%`,
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                            </div>
                          )}
                          {item.capacityStats.total.adminApprovalsPending >
                            0 && (
                            <div>
                              {item.capacityStats.total.adminApprovalsPending >
                              0 ? (
                                <div className="progressContainer ">
                                  {item.capacityStats.total
                                    .adminApprovalsPending > 0 && (
                                    <div className="progressWrapper">
                                      <p className="progressText">
                                        Admin Approval Pending{" "}
                                        <span className="font-weight-bold">
                                          (
                                          {
                                            item.capacityStats.total
                                              .adminApprovalsPending
                                          }
                                          )
                                        </span>{" "}
                                      </p>
                                      <div className="progressBar pendingAdmin">
                                        <div
                                          className="progressFill"
                                          style={{
                                            width: `${findPercentage(item.capacityStats.total.adminApprovalsPending, item.capacityStats.total.registered)}%`,
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                              <div className="statsActions ">
                                {item.capacityStats.total
                                  .adminApprovalsPending > 0 && (
                                  <Link
                                    to={`/activity-registrations/${item._id}`}
                                  >
                                    <div className="statsActionsButton pe-3 me-3 ">
                                      Approve Request(s)
                                    </div>
                                  </Link>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            )}
          {item.capacityStats &&
            item.capacityType === "unlimited" &&
            item.capacityStats.total.registered > 0 && (
              <Col xl={12} lg={12} md={12} sm={12} xs={12} className="p-0">
                <div
                  className={`activityStats mt-1 ${
                    item.capacityStats &&
                    item.capacityStats.total &&
                    item.capacityStats.total.registeredPercentage === 100
                      ? "alert-danger"
                      : item.capacityStats &&
                          item.capacityStats.total &&
                          item.capacityStats.total.registeredPercentage > 90
                        ? "alert-warning"
                        : ""
                  }`}
                >
                  <Row className="w-100">
                    <Col
                      xl={12}
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className=" pt-1"
                    >
                      {/* {isActivityPaid(item) && (
                        <div className="pieContainer mb-0 me-4">
                          <div className="pie-wrapper">
                            <PieChart
                              animate
                              animationDuration={500}
                              animationEasing="ease-out"
                              center={[55, 65]}
                              lengthAngle={360}
                              lineWidth={50}
                              paddingAngle={5}
                              radius={50}
                              startAngle={0}
                              viewBoxSize={[120, 120]}
                              label={({ dataEntry }) => `${dataEntry.value}`}
                              labelPosition={70}
                              labelStyle={{
                                fontSize: "12px",
                                fill: "#FFFFFA",
                                fontWeight: "bold",
                                textShadow:
                                  "1px 1px 3px rgba(255, 255, 255, 0.4)",
                              }}
                              data={[
                                {
                                  title: "Confirmed",
                                  value:
                                    item.capacityStats.total
                                      .registeredConfirmed,
                                  color: "#000",
                                }, // Lighter green
                                {
                                  title: "Not Confirmed",
                                  value:
                                    item.capacityStats.total
                                      .registeredNotConfirmed,
                                  color: "#999",
                                }, // Yellow
                              ]}
                              style={{
                                width: "100%",
                                height: "auto",
                              }}
                            />
                          </div>
                          <div className="pieLabels">
                            <div className="displayRow mt-0 p-0 ">
                              <div className="leftText">
                                <p>
                                  <span className="confirmedBox"></span>{" "}
                                  Confirmed :{" "}
                                  {item.capacityStats.total.registeredConfirmed}{" "}
                                </p>
                              </div>
                              <div className="rightText">
                                <p className="mb-0">
                                  <span className="count ">
                                    (
                                    {findPercentage(
                                      item.capacityStats.total
                                        .registeredConfirmed,
                                      item.capacityStats.total.registered
                                    )}
                                    %)
                                  </span>
                                </p>
                              </div>
                            </div>

                            <div className="displayRow mt-0 p-0">
                              <div className="leftText">
                                {" "}
                                <p>
                                  <span className="notConfirmedBox"></span> Not
                                  Confirmed :{" "}
                                  {
                                    item.capacityStats.total
                                      .registeredNotConfirmed
                                  }{" "}
                                </p>
                              </div>
                              <div className="rightText">
                                <p className="mb-0">
                                  <span className="count ">
                                    (
                                    {findPercentage(
                                      item.capacityStats.total
                                        .registeredNotConfirmed,
                                      item.capacityStats.total.registered
                                    )}
                                    %)
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div className="displayRow  mt-0  p-0">
                              <div className="leftText">
                                {" "}
                                <p className="soFar font-weight-bold">
                                  Total Registrations:{" "}
                                  {item.capacityStats.total.registered}
                                </p>{" "}
                              </div>
                              <div className="rightText">
                                <p className="mb-0">
                                  <span className="count font-weight-bold  soFar">
                                    (
                                    {findPercentage(
                                      item.capacityStats.total.registered,
                                      item.capacityStats.total.registered
                                    )}
                                    %)
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )} */}
                      <div className="d-flex flex-wrap align-items-center justify-content-start me-3">
                        {item.registrationsCount > 0 && (
                          <div className={`holder border-0 ms-0 me-3`}>
                            <p className="title">
                              Total Registrations (Members + Others):{" "}
                            </p>
                            <h2 className="infoCount ms-2">
                              {item.capacityStats.total.registered}
                            </h2>
                          </div>
                        )}

                        <div>
                          <Link
                            to={`/activity-registrations/${item._id}`}
                            className="activityFeeCardMargin d-flex align-items-center justify-content-center purple cursor-pointer "
                          >
                            <div className="carTopHolder mb-0 border-0 pb-0 py-1">
                              <div className="carLeftHolder activity">
                                {" "}
                                <FaFileAlt size={18} className="me-1" />
                                Manage Registrations
                                <i className="regType">(Members Only)</i> &nbsp;
                                - &nbsp;{" "}
                                <b>
                                  {item.registrationsCount > 0
                                    ? `${item.registrationsCount}`
                                    : "0"}{" "}
                                </b>
                              </div>
                              <div className="carRightHolder"></div>
                            </div>
                            {/* <div className="carDownHolder warning">{item.stats.cars}</div> */}
                          </Link>
                        </div>
                        {item.capacityStats.total.registered > 0 && (
                          <div>
                            <Link
                              to={`/activity-registrations/${item._id}`}
                              className="activityFeeCardMargin d-flex align-items-center justify-content-center primary cursor-pointer "
                            >
                              <div className="carTopHolder mb-0 border-0 pb-0 py-1">
                                <div className="carLeftHolder activity">
                                  {" "}
                                  <FaFileAlt size={18} className="me-1" />
                                  Total Registrations{" "}
                                  <i className="regType">
                                    (Members + Others)
                                  </i>{" "}
                                  &nbsp; - &nbsp;{" "}
                                  <b>
                                    {item.capacityStats.total.registered > 0
                                      ? `${item.capacityStats.total.registered}`
                                      : "0"}{" "}
                                  </b>
                                </div>
                                <div className="carRightHolder"></div>
                              </div>
                              {/* <div className="carDownHolder warning">{item.stats.cars}</div> */}
                            </Link>
                          </div>
                        )}
                        {/* {isActivityFree(item) &&
                          <div>
                            <Link to={`/activity-registrations/${item._id}?status=reconfirmedMembers`} className="me-3 activityFeeCardMargin d-flex align-items-center justify-content-center green cursor-pointer ">
                              <div className="carTopHolder mb-0 border-0 pb-0 py-1">
                                <div className="carLeftHolder activity"> <FaCircleCheck size={17} className="me-1" />Confirmed Participants {item.capacityStats.total.reconfirmedRegistrations > 0 ? `(${item.capacityStats.total.reconfirmedRegistrations})` : "(0)"} </div>
                                <div className="carRightHolder">

                                </div>
                              </div>
                              
                            </Link>
                          </div>} */}
                        {isActivityPaid(item) && (
                          <div>
                            <Link
                              to={`/activity-registrations/${item._id}?status=confirmedMembers`}
                              className="activityFeeCardMargin me-3 d-flex align-items-center justify-content-center green cursor-pointer "
                            >
                              <div className="carTopHolder mb-0 border-0 pb-0 py-1">
                                <div className="carLeftHolder activity">
                                  {" "}
                                  <FaCircleCheck size={17} className="me-1" />
                                  Confirmed Registrations{" "}
                                  <i className="regType">
                                    (Members + Others)
                                  </i>{" "}
                                  &nbsp; - &nbsp;{" "}
                                  <b>
                                    {" "}
                                    {item.capacityStats.total
                                      .registeredConfirmed > 0
                                      ? `(${item.capacityStats.total.registeredConfirmed})`
                                      : "(0)"}{" "}
                                  </b>
                                </div>
                                <div className="carRightHolder"></div>
                              </div>
                            </Link>
                          </div>
                        )}
                        <div className="d-flex flex-wrap ">
                          <div className="me-3 ms-1">
                            {item.capacityStats.total.registeredPaymentPending >
                            0 ? (
                              <div className="progressContainer ">
                                {item.capacityStats.total
                                  .registeredPaymentPending > 0 && (
                                  <div className="progressWrapper">
                                    <p className="progressText">
                                      Payment Pending:{" "}
                                      <span className="font-weight-bold">
                                        (
                                        {
                                          item.capacityStats.total
                                            .registeredPaymentPending
                                        }
                                        )
                                      </span>
                                    </p>
                                    <div className="progressBar pendingPayment">
                                      <div
                                        className="progressFill"
                                        style={{
                                          width: `${findPercentage(
                                            item.capacityStats.total
                                              .registeredPaymentPending,
                                            item.capacityStats.total.registered,
                                          )}%`,
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            ) : null}
                          </div>

                          <div className="ms-1">
                            {item.capacityStats.total.registeredPaymentPending >
                              0 ||
                            item.capacityStats.total.adminApprovalsPending >
                              0 ? (
                              <div className="progressContainer ">
                                {item.capacityStats.total
                                  .adminApprovalsPending > 0 && (
                                  <div className="progressWrapper">
                                    <p className="progressText">
                                      Admin Approval Pending
                                      <span className="font-weight-bold">
                                        (
                                        {
                                          item.capacityStats.total
                                            .adminApprovalsPending
                                        }
                                        )
                                      </span>{" "}
                                    </p>
                                    <div className="progressBar pendingAdmin">
                                      <div
                                        className="progressFill"
                                        style={{
                                          width: `${findPercentage(
                                            item.capacityStats.total
                                              .adminApprovalsPending,
                                            item.capacityStats.total.registered,
                                          )}%`,
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            ) : null}
                            <div className="statsActions ">
                              {item.capacityStats.total.adminApprovalsPending >
                                0 && (
                                <Link
                                  to={`/activity-registrations/${item._id}`}
                                >
                                  <div className="statsActionsButton pe-3 me-3 ">
                                    Approve Request(s)
                                  </div>
                                </Link>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            )}
          {/* {item.capacityType === "unlimited" &&
            item.capacityStats.total.registered > 0 &&
            isActivityFree(item) &&
            isAnyOtherAllowed(item) && (
              <Col xl={12} lg={12} md={12} sm={12} xs={12} className="p-0">
                <div
                  className={`activityStats mt-1 ${item.capacityStats &&
                    item.capacityStats.total &&
                    item.capacityStats.total.registeredPercentage === 100
                    ? "alert-danger"
                    : item.capacityStats &&
                      item.capacityStats.total &&
                      item.capacityStats.total.registeredPercentage > 90
                      ? "alert-warning"
                      : ""
                    }`}
                >
                  <Row className="w-100">
                    <Col
                      xl={12}
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className=" d-flex align-items-center justify-content-start flex-wrap"
                    >
                      {item.capacityStats &&
                        item.capacityStats.total.registered > 0 && (
                          <div className="d-flex flex-wrap  align-items-start justify-content-start">
                            <div class="progress-group mb-3">
                              Members{" "}
                              <small className="text-secondary ms-1">
                                (
                                {findPercentage(
                                  item.capacityStats.members.registered,
                                  item.capacityStats.total.registered
                                )}
                                %)
                              </small>
                              <span class="float-right">
                                <small>
                                  ({item.capacityStats.members.registered})
                                </small>
                              </span>
                              <div class="progress progress-sm">
                                <div
                                  class="progress-bar bg-primary"
                                  style={{
                                    width: `${findPercentage(
                                      item.capacityStats.members.registered,
                                      item.capacityStats.total.registered
                                    )}%`,
                                  }}
                                ></div>
                              </div>
                              {isActivityPaid(item) && item.capacityStats.members.registeredConfirmed >
                                0 && (
                                  <div className=" details mt-1">
                                    <span className="text-orange">
                                      <small className="me-1">
                                        {
                                          item.capacityStats.members
                                            .registeredConfirmed
                                        }
                                      </small>{" "}
                                      Confirmed Request(s)
                                    </span>
                                  </div>
                                )}
                              {isActivityPaid(item) && item.capacityStats.members
                                .registeredNotConfirmed > 0 && (
                                  <div className=" details mt-1">
                                    <span className="text-info">
                                      <small className="me-1">
                                        {
                                          item.capacityStats.members
                                            .registeredNotConfirmed
                                        }
                                      </small>{" "}
                                      Not Confirmed Request(s)
                                    </span>
                                  </div>
                                )}
                            </div>

                            {item.partnerFeaturesSettings &&
                              item.partnerFeaturesSettings.allowed === "1" && (
                                <div class="progress-group mb-3">
                                  Partner{" "}
                                  <small className="text-secondary ms-1">
                                    (
                                    {findPercentage(
                                      item.capacityStats.partners.registered,
                                      item.capacityStats.total.registered
                                    )}
                                    %)
                                  </small>
                                  <span class="float-right">
                                    <small>
                                      ({item.capacityStats.partners.registered})
                                    </small>
                                  </span>
                                  <div class="progress progress-sm">
                                    <div
                                      class="progress-bar bg-info"
                                      style={{
                                        width: `${findPercentage(
                                          item.capacityStats.partners
                                            .registered,
                                          item.capacityStats.total.registered
                                        )}%`,
                                      }}
                                    ></div>
                                  </div>
                                  {isActivityPaid(item) && item.capacityStats.partners
                                    .registeredConfirmed > 0 && (
                                      <div className=" details mt-1">
                                        <span className="text-orange">
                                          <small className="me-1">
                                            {
                                              item.capacityStats.partners
                                                .registeredConfirmed
                                            }
                                          </small>{" "}
                                          Confirmed Request(s)
                                        </span>
                                      </div>
                                    )}
                                  {isActivityPaid(item) && item.capacityStats.partners
                                    .registeredNotConfirmed > 0 && (
                                      <div className=" details mt-1">
                                        <span className="text-info">
                                          <small className="me-1">
                                            {
                                              item.capacityStats.partners
                                                .registeredNotConfirmed
                                            }
                                          </small>{" "}
                                          Not Confirmed Request(s)
                                        </span>
                                      </div>
                                    )}
                                </div>
                              )}

                            {item.guestFeaturesSettings &&
                              item.guestFeaturesSettings.allowed === "1" && (
                                <div class="progress-group mb-3">
                                  <span class="progress-text">
                                    Guest{" "}
                                    <small className="text-secondary ms-1">
                                      (
                                      {findPercentage(
                                        item.capacityStats.guests.registered,
                                        item.capacityStats.total.registered
                                      )}
                                      %)
                                    </small>
                                  </span>
                                  <span class="float-right">
                                    <small>
                                      ({item.capacityStats.guests.registered})
                                    </small>
                                  </span>
                                  <div class="progress progress-sm">
                                    <div
                                      class="progress-bar bg-pink"
                                      style={{
                                        width: `${findPercentage(
                                          item.capacityStats.guests.registered,
                                          item.capacityStats.total.registered
                                        )}%`,
                                      }}
                                    ></div>
                                  </div>
                                  {isActivityPaid(item) && item.capacityStats.guests
                                    .registeredConfirmed > 0 && (
                                      <div className=" details mt-1">
                                        <span className="text-orange">
                                          <small className="me-1">
                                            {
                                              item.capacityStats.guests
                                                .registeredConfirmed
                                            }
                                          </small>{" "}
                                          Confirmed Request(s)
                                        </span>
                                      </div>
                                    )}
                                  {isActivityPaid(item) && item.capacityStats.guests
                                    .registeredNotConfirmed > 0 && (
                                      <div className=" details mt-1">
                                        <span className="text-info">
                                          <small className="me-1">
                                            {
                                              item.capacityStats.guests
                                                .registeredNotConfirmed
                                            }
                                          </small>{" "}
                                          Not Confirmed Request(s)
                                        </span>
                                      </div>
                                    )}
                                </div>
                              )}

                            {item.kidsFeaturesSettings &&
                              item.kidsFeaturesSettings.allowed === "1" && (
                                <div class="progress-group mb-3">
                                  <span class="progress-text">
                                    Kids{" "}
                                    <small className="text-secondary ms-1">
                                      (
                                      {findPercentage(
                                        item.capacityStats.kids.registered,
                                        item.capacityStats.total.registered
                                      )}
                                      %)
                                    </small>
                                  </span>
                                  <span class="float-right">
                                    <small>
                                      ({item.capacityStats.kids.registered})
                                    </small>
                                  </span>
                                  <div class="progress progress-sm">
                                    <div
                                      class="progress-bar bg-purple"
                                      style={{
                                        width: `${findPercentage(
                                          item.capacityStats.kids.registered,
                                          item.capacityStats.total.registered
                                        )}%`,
                                      }}
                                    ></div>
                                  </div>
                                  {isActivityPaid(item) && item.capacityStats.kids.registeredConfirmed >
                                    0 && (
                                      <div className=" details mt-1">
                                        <span className="text-orange">
                                          <small className="me-1">
                                            {
                                              item.capacityStats.kids
                                                .registeredConfirmed
                                            }
                                          </small>{" "}
                                          Confirmed Request(s)
                                        </span>
                                      </div>
                                    )}
                                  {isActivityPaid(item) && item.capacityStats.kids
                                    .registeredNotConfirmed > 0 && (
                                      <div className=" details mt-1">
                                        <span className="text-info">
                                          <small className="me-1">
                                            {
                                              item.capacityStats.kids
                                                .registeredNotConfirmed
                                            }
                                          </small>{" "}
                                          Not Confirmed Request(s)
                                        </span>
                                      </div>
                                    )}
                                </div>
                              )}
                            {item.capacityStats.total.adminApprovalsPending >
                              0 && (
                                <div class="progress-group large mb-3">
                                  <span class="progress-text">
                                    Admin Approval Pending{" "}
                                    <small className="text-secondary ms-1">

                                    </small>
                                  </span>
                                  <span class="float-right">
                                    <small>
                                      (
                                      {
                                        item.capacityStats.total
                                          .adminApprovalsPending
                                      })
                                    </small>
                                  </span>
                                  <div class="progress progress-sm">
                                    <div
                                      class="progress-bar bg-warning"
                                      style={{
                                        width: `${findPercentage(
                                          item.capacityStats.total
                                            .adminApprovalsPending,
                                          item.capacityStats.total.registered
                                        )}%`,
                                      }}
                                    ></div>
                                  </div>
                                  <div className="details mt-1">
                                    {item.capacityStats.total
                                      .adminApprovalsPending > 0 && (
                                        <Link
                                          to={`/activity-registrations/${item._id}`}
                                        >
                                          <div className="statsActionsButton pe-3 me-3 ">
                                            Approve Request(s)
                                          </div>
                                        </Link>
                                      )}
                                  </div>
                                </div>
                              )}
                            {item.capacityStats.total.registeredPaymentPending >
                              0 && (
                                <div class="progress-group large mb-3">
                                  <span class="progress-text">
                                    Payment Pending{" "}
                                    <small className="text-secondary ms-1">
                                      (
                                      {findPercentage(
                                        item.capacityStats.total
                                          .registeredPaymentPending,
                                        item.capacityStats.total.registered
                                      )}
                                      %)
                                    </small>
                                  </span>
                                  <span class="float-right">
                                    <small>
                                      (
                                      {
                                        item.capacityStats.total
                                          .registeredPaymentPending
                                      }
                                      /{item.capacityStats.total.registered})
                                    </small>
                                  </span>
                                  <div class="progress progress-sm">
                                    <div
                                      class="progress-bar bg-danger"
                                      style={{
                                        width: `${findPercentage(
                                          item.capacityStats.total
                                            .registeredPaymentPending,
                                          item.capacityStats.total.registered
                                        )}%`,
                                      }}
                                    ></div>
                                  </div>
                                  <div className="details mt-1"></div>
                                </div>
                              )}
                          </div>
                        )}
                    </Col>
                  </Row>
                </div>
              </Col>
            )} */}
        </Row>

        {/* <StatsListing
          border="border"
          heading="Stats"
          clickable={true}
          items={[
            {
              title: "Registrations Count",
              value: item.registrationsCount,
              url: `/activity-registrations/${item._id}`,
            },
            {
              title: "Confirmed Registrations",
              value: item.registrationsCountConfirmed,
              url: `/activity-registrations/${item._id}?status=1`,
            },
            {
              title: "Not Confirmed Registrations",
              value:
                item.registrationsCountNotConfirmed,
              url: `/activity-registrations/${item._id}?status=0`,
            },
            {
              title: "Comments Count",
              value: item.commentsCount,
              url: `/activity-comments/${item._id}`,
            },
            {
              title: "Likes Count",
              value: item.likesCount,
              url: `/activity-likes/${item._id}`,
            },
          ]}
        /> */}
      </Card.Body>
    </Card>
  );
};

export default Item;
